import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import EricAnalyst from './EricAnalyst.js';

class Eric extends Component {
  render() {
    return (
      <div className="content-wrapper">
        <div className="content-body">
          <Switch>
            {/* Una sola Route (no exact) para que /eric y /eric/conversaciones/:id
                rendericen la misma instancia de EricAnalyst y no haya remount al
                navegar entre conversaciones. EricAnalyst parsea el id desde la URL. */}
            <Route path={this.props.match.url} component={EricAnalyst} />
          </Switch>
        </div>
      </div>
    );
  }
}

export default Eric;
